import React, {useState} from 'react';
import {Button, Popconfirm, Popover, Select, Tree} from 'antd';
import {DataNode} from 'antd/lib/tree';
import {ArticleCatalogsTreeData} from '../../pages/manage/articleList';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function DeleteArticleBtn(props: {id: number; refresh: () => any}) {
  const deleteHook = useOpenApiFpRequest(ArticleApi, ArticleApi.prototype.articleDeletePost);

  return (
    <>
      <Popconfirm
        title={'确认要删除文章吗'}
        onConfirm={() =>
          deleteHook
            .request({
              findParams: {
                id: props.id,
              },
            })
            .then(props.refresh)
            .catch(CommonApiErrorHandler)
        }>
        <a>删除</a>
      </Popconfirm>
    </>
  );
}
